// src/theme/atomic/common.ts
var common = {
  0: "#000000",
  100: "#ffffff"
};
var common_default = common;

export { common_default as default };
